module.exports = __webpack_public_path__ + "static/media/grid-menu-active.fee6f142.svg";